import gql from 'graphql-tag';

const ADD_PRODUCT_TO_PRICESHEET = gql`
  mutation AddProductToPricesheet ($pricesheetId: String!, $productId: String!, $price: Int!) {
    pricesheet: addProductToPricesheet(pricesheetId: $pricesheetId, productId: $productId, price: $price) {
      price
      product {
        id,
        inRutaCode,
        inRutaShortDescriptionSpanish
      }
    }
  }
`;

export default ADD_PRODUCT_TO_PRICESHEET;
